import React from 'react';

const CanvasViewer = ({ canvasRef, annotationCanvasRef, brightness, brightnessMask, cursorStyle, handlers }) => {
  return (
    <div className="bg-slate-500 w-full h-full relative overflow-hidden">
      <canvas ref={canvasRef} className="w-full h-full absolute top-0 left-0 z-0" style={{ filter: `brightness(${brightness})` }} />
      <canvas
        ref={annotationCanvasRef}
        className="w-full h-full absolute top-0 left-0 z-10"
        {...handlers}
        style={{ cursor: cursorStyle, filter: `opacity(${brightnessMask})`, touchAction: 'none' }}
      />
    </div>
  );
};

export default CanvasViewer;